import { render, staticRenderFns } from "./IPKelistrikanView.vue?vue&type=template&id=73059145&scoped=true&lang=pug&"
import script from "./IPKelistrikanView.vue?vue&type=script&lang=js&"
export * from "./IPKelistrikanView.vue?vue&type=script&lang=js&"
import style0 from "./IPKelistrikanView.vue?vue&type=style&index=0&id=73059145&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73059145",
  null
  
)

export default component.exports